export default __webpack_public_path__ + "static/19-7d0a91f8314d97a8bc4920e9020fccfa.jpg";